import { Markdown } from '../../lib/components/markdown/Markdown';

interface ProductDescriptionProps {
	className?: string;
	children?: string;
}

const ProductDescription = ({ className, children }: ProductDescriptionProps) => {
	if (!children) return null;

	return (
		<Markdown className={className} data-tid="product-description">
			{children}
		</Markdown>
	);
};

export default ProductDescription;
